"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import Axios from "@/lib/axiosConfig";
import { useAuth } from "@/context/Auth";

export type PartnershipTier = "bronze" | "silver" | "gold";

interface PartnershipUpgradeResponse {
  success: boolean;
  message: string | null;
  responseObject: string;
  statusCode: number;
}

export const usePartnershipUpgrade = () => {
  const { getAPIRequestTokenHeaders } = useAuth();
  const queryClient = useQueryClient();

  return useMutation<PartnershipUpgradeResponse, Error, { tier: PartnershipTier }>({
    mutationFn: async ({ tier }) => {
      const res = await Axios.post(
        "/business-profiles/partnerships/upgrade",
        { tier },
        { headers: getAPIRequestTokenHeaders() }
      );
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["business"] });
      queryClient.invalidateQueries({ queryKey: ["business-profiles"] });
    },
  });
};
